<template>
    <div />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { RESOURCE_MANAGER_STATUS, resourceManagerRequest } from "@/utils/CreativeIntelligenceApi";

// this is an insane component that should be a function
export default defineComponent({
    name: "CampaignDataProvider",

    props: {
        options: {
            type: Object
        },

        refreshCounter: {
            type: Number,
            default: 0
        },

        requestOptions: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    emits: ["data", "error", "loading"],

    data() {
        return {
            isLoading: false,
            fetchCount: 0
        };
    },

    watch: {
        options: {
            immediate: true,
            deep: true,
            handler() {
                this.fetch();
            }
        },

        refreshCounter() {
            this.fetch();
        }
    },

    methods: {
        async fetch() {
            this.fetchCount += 1;

            try {
                if (!this.$store.state.auth.me?.reference) {
                    throw new Error("User ID is not available");
                }

                this.isLoading = true;
                this.$emit("loading", this.isLoading);

                const response = await resourceManagerRequest({
                    id: this.$store.state.auth.me?.reference,
                    body: this.options
                });

                if (response.data?.status === RESOURCE_MANAGER_STATUS.IN_PROGRESS) {
                    setTimeout(this.fetch, 2500);

                    return;
                }

                if (response.data?.status === RESOURCE_MANAGER_STATUS.FAILED) {
                    try {
                        this.$emit("error", { message: JSON.parse(response.data.output.fail as string) });
                    } catch {
                        this.$emit("error", { message: response.data.output.fail });
                    }

                    return;
                }

                this.$emit("data", { ...response.data, searchOptions: this.options });

                this.isLoading = false;
                this.$emit("loading", this.isLoading);
            } catch (e) {
                this.$emit("error", e);
                this.isLoading = false;
                this.$emit("loading", this.isLoading);
                throw e;
            }
        }
    }
});
</script>
